module.exports = __webpack_public_path__ + "assets/img/ability29.9dda2b88.png";